module.exports = __webpack_public_path__ + "static/Laptop2_mobileES-851fcfc893c34c9a120301cde247724a.mp4";